import moment from 'moment';
import type { Types } from '../types';
import { fromId } from '../to/input/util/util';
import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';

export function schedules (
  input:   Partial<Types.toOutput>,
  options: Pick<Types.toOptions, 'idKey'> = {}
): Partial<CoreTypes.SerializedWithOptionalId.Schedule> {
  // set default idKey if not provided
  if (!options.idKey) options.idKey = 'id';

  const warnings: string[] = [];

  const schedule            = input.coreData;
  const eventConfigurations = input.output?.at(0)?.events;

  if (!schedule           ) throw new Error('Missing `coreData` in input.');
  if (!eventConfigurations) throw new Error('Missing `output.events` in input.');

  // check on later to ensure that all events are updated
  const eventsToUpdate = new Set(schedule.events?.map(x => getVertexId(x, options)));

  eventConfigurations.forEach(({ id: collectionAndId, ...placement }) => {
    // locate the corresponding event/locked time
    const { collection, entityId: id } = fromId.aggregate(collectionAndId);
    const event = (() => {
      if (collection == 'events') {
        return schedule.events?.find(x => getVertexId(x, options) == id);
      }
      if (collection == 'lockedTimes') {
        return schedule.lockedTimes?.find(x => getVertexId(x, options) == id);
      }
      throw new Error(`Unknown collection "${collection}" in id "${collectionAndId}"`);
    })();


    if (!event) {
      warnings.push(`Could not find ${id} (${collectionAndId}) in ${collection} collection.`);
      return;
    }

    event.parked   = false;
    event.start    = moment.utc('1970-01-05T00:00').add(placement.day, 'days').add(placement.start, 'minutes').toISOString();
    event.end      = moment.utc('1970-01-05T00:00').add(placement.day, 'days').add(placement.end,   'minutes').toISOString();
    event.duration = placement.end - placement.start;

    if (collection == 'events') {
      (event as CoreTypes.Serialized.Event).inLocations = placement.dependencies?.filter(Boolean) ?? [];

      // remove from events to be updates
      eventsToUpdate.delete(id);
    }
  });

  // check if there are events that were not updated
  if (eventsToUpdate.size) {
    warnings.push(`The following events were not updated: ${[...eventsToUpdate].join(', ')}`);
  }


  return Object.assign(schedule, {
    meta: {
      ...warnings.length && { warnings: warnings }
    }
  });
};